import $ from 'jquery';
import { eventEmitter } from '../global/eventEmitter';
import { TEXTCOLLAPSED,ERROR_MESSAGE_CLASS ,INPUTERROR, CHECK_CART, CHECKED } from '../constants/classes';
import Notifications from '../global/Notifications';
import productDetailErrors from '../templates/productDetailErrors.hbs';
import TrackingService from '../services/TrackingService';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    PRODUCT_QTY: '.js-pdp-qty',
    FREQUENT_PDT_DESC: '.js-frequent-desc',
    FREQUENT_PDT_DESC_VIEW: '.view-cta',
    PARENT_TOAST: '.parent-toast',
    STEPPER_VALUE: '.js-stepperValue',
    ADD_TO_CART: '.btn_primary',
    TOAST: '.toast',
    MAX_QTY: '.js-max-value',
    INVENTORY_MESSAGE: '.js-inventory-msg',
    PRODUCT_NAME: 'product-name',
    IN_STOCK_QTY: 'data-in-stock',
    MAX_VALUE: 'max-value',
    MAX_VALUE_ATTR: 'data-max-qty',
    TOAST_MSG: '.js-toast-msg',
    STEPPER_INPUT: 'stepper',
    CUSTOM_CHECKBOX: '.js-custom-checkbox',
    DEBRIS_DIVERTER: 'debrisDiverter',
    DEBRIS_DIVERTER_QTY: 'data-qty-available',
    PRODUCT_ITEM_VARIABLE: 'js_productItem'
};

/**
 * Hide Default browser checkbox
 * Control it using label and custom style
 * 
 *
 * @class CheckboxDependenciesView
 * @constructor
 */
export default class ProductDetailView {
    constructor($element) {
        console.log('PDP View JS');
        this.$element = $element;
        this.eventEmitter = eventEmitter;
        this.productItem = window[SELECTORS.PRODUCT_ITEM_VARIABLE];

        return this.setupHandlers()
            .createChildren()
            .addQtyChangeListener()
            .enable()
            .trackViewItem()
            .addToCartClicked()
            .inputEntered();
    }

    addQtyChangeListener() {
        this.eventEmitter.on('qty-change', (param1) => {
            this.onPdpQtyChange(param1);
          });
        return this;
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.onPdpQtyChangeHandler = this.onPdpQtyChange.bind(this);
        this.onFrequentPdtDescViewCTAHandler = this.onFrequentPdtDescViewCTA.bind(this);
        this.oncartClickedHandler = this.oncartClicked.bind(this);
        this.onInputEnteredHandler = this.onInputEntered.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$parentToast = this.$element.find(SELECTORS.PARENT_TOAST);
        this.$pdpQty = this.$element.find(SELECTORS.PRODUCT_QTY);
        this.$frequentPdtDesc = this.$element.find(SELECTORS.FREQUENT_PDT_DESC);
        this.$frequentPdtDescView = this.$element.find(SELECTORS.FREQUENT_PDT_DESC_VIEW);
        this.$stepperValue = this.$element.find(SELECTORS.STEPPER_VALUE);
        this.$addToCart = this.$element.find(SELECTORS.ADD_TO_CART);
        this.$closeIcon = this.$element.find(SELECTORS.CLOSE_ICON);
        this.$toast = this.$element.find(SELECTORS.TOAST);
        this.$maxQty = this.$element.find(SELECTORS.MAX_QTY);
        this.$inventoryMessage = this.$element.find(SELECTORS.INVENTORY_MESSAGE);
        this.$maxQtyDiv = document.getElementById(SELECTORS.MAX_VALUE);
        this.$productNameElement = document.getElementById(SELECTORS.PRODUCT_NAME);
        this.$toastMsg = this.$element.find(SELECTORS.TOAST_MSG);
        this.notifications = new Notifications();
        this.$inputValue = document.getElementById(SELECTORS.STEPPER_INPUT);
        this.$debrisDiverterQty = document.getElementById(SELECTORS.DEBRIS_DIVERTER);
        this.$customCheckbox = this.$element.find(SELECTORS.CUSTOM_CHECKBOX);
        this.trackingService = new TrackingService();
        return this;
    }

    /**
     * Toggles custom checkbox style
     * Triggers a click on default checkbox
     *
     * @method onParentClick
     * @public
     * @chainable
     */
     onPdpQtyChange(qty) {
         let maxQty;
         let inStockQty;
         this.$pdpQty.text(qty);
         inStockQty = this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_QTY);
         
         if (this.$maxQtyDiv !== null ) {
             maxQty = this.$maxQtyDiv.getAttribute(SELECTORS.MAX_VALUE_ATTR);

             if (qty > maxQty && !this.$addToCart.hasClass(CHECK_CART)) {
                 const templateData = {
                     notificationMessage: NOTIFICATIONS.MAXIMUM_ALLOWED_QTY_ERROR
                 }
                 this.notifications.showErrorNotification(productDetailErrors(templateData), ERROR_MESSAGE_CLASS);

                 this.$stepperValue.addClass(INPUTERROR)
                 this.$inventoryMessage.addClass(INPUTERROR);
                 this.$addToCart.prop('disabled', true);
             }
             else if (qty <= maxQty && !this.$addToCart.hasClass(CHECK_CART)) {
                 this.notifications.resetMessages();
                 this.$stepperValue.removeClass(INPUTERROR)
                 this.$inventoryMessage.removeClass(INPUTERROR)
                 this.$addToCart.prop('disabled', false);
             }

         }
         if (inStockQty !== null || inStockQty !== undefined) {
             if (qty <= inStockQty && this.$addToCart.hasClass(CHECK_CART)) {
                 this.notifications.resetMessages();
                 this.$stepperValue.removeClass(INPUTERROR)
                 this.$inventoryMessage.removeClass(INPUTERROR)
                 this.$addToCart.prop('disabled', false);
                 this.$addToCart.removeClass(CHECK_CART)
             }
         }
        
        return this;
    }

    /**
     * When Add To Cart
     * button is clicked
     *
     * @method onCartClicked
     * @public
     * @chainable
     */
    oncartClicked(e) {
        const event = e;
        let inStockQty;
        let inStockDebrisDiverterQty;
        let error = false;
        let addAccessory = false;
        inStockQty = this.$productNameElement.getAttribute(SELECTORS.IN_STOCK_QTY);
        if(this.$pdpQty.length) {
            if(this.$customCheckbox.hasClass(CHECKED)) {
                addAccessory = true;
                inStockDebrisDiverterQty = this.$debrisDiverterQty.getAttribute(SELECTORS.DEBRIS_DIVERTER_QTY)
                if(inStockDebrisDiverterQty !== null && inStockDebrisDiverterQty !== undefined) {
                    if(parseInt(this.$pdpQty.text()) > inStockDebrisDiverterQty && this.$customCheckbox.hasClass(CHECKED)) {
                        const templateData = {
                            notificationMessage: NOTIFICATIONS.AVAILABLE_DEBRIS_DIVERTER_QTY
                        }
                        this.notifications.showErrorNotification(productDetailErrors(templateData), ERROR_MESSAGE_CLASS);
                        error = true;
                        event.preventDefault();
                    }
                }
            }
            
            if (inStockQty !== null && inStockQty !== undefined) {
                if(parseInt(this.$pdpQty.text()) > parseInt(inStockQty)) {
                    const templateData = {
                        notificationMessage: NOTIFICATIONS.AVAILABLE_QTY_ERROR
                    }
                    this.notifications.showErrorNotification(productDetailErrors(templateData), ERROR_MESSAGE_CLASS);
                    this.$addToCart.addClass(CHECK_CART)
                    this.$inventoryMessage.addClass(INPUTERROR);
                    this.$stepperValue.addClass(INPUTERROR);
                    this.$addToCart.prop('disabled', true);
                    error = true;
                    event.preventDefault();
                }
            }                    
        } else {
            if(parseInt(this.$inputValue.value) > parseInt(inStockQty)) {
                const templateData = {
                    notificationMessage: NOTIFICATIONS.AVAILABLE_QTY_ERROR
                }
                this.notifications.showErrorNotification(productDetailErrors(templateData), ERROR_MESSAGE_CLASS);
                this.$addToCart.addClass(CHECK_CART)
                this.$inventoryMessage.addClass(INPUTERROR);
                this.$stepperValue.addClass(INPUTERROR);
                this.$addToCart.prop('disabled', true);
                error = true;
                event.preventDefault();
            }
        }      
        if(!error){
            this.trackAddToCart(parseInt(this.$inputValue.value), addAccessory);
        }
        return this;
    }

    onFrequentPdtDescViewCTA() {
        console.log('View More, View Less');
        if(this.$frequentPdtDesc.hasClass(TEXTCOLLAPSED)){
            this.$frequentPdtDesc.removeClass(TEXTCOLLAPSED)
        } else{
            this.$frequentPdtDesc.addClass(TEXTCOLLAPSED) 
        }
        return this;
    }
    /**
     * When user enters
     * input in qty input box
     *
     * @method onInputEntered
     * @public
     * @chainable
     */
    onInputEntered() {
        console.log('user input entered');
        this.$pdpQty.text(this.$inputValue.value)
        this.onPdpQtyChange(parseInt(this.$inputValue.value))
    }
    
    /**
     * Ecommerce tracking call - View Item
     *
     * @method trackViewItem
     * @public
     * @chainable
     */
    trackViewItem(){
        this.trackingService.viewItem(this.productItem);
        return this;
    }

    /**
     * Ecommerce tracking call - Add To Cart
     *
     * @method trackAddToCart
     * @public
     */
    trackAddToCart(quantity, addAccessory){
        this.productItem.ProductQuantity = quantity;
        if(addAccessory){
            this.productItem.ProductReference = {
                ProductCode : this.productItem.ProductReferenceViewModel.ProductCode,
                ProductName : this.productItem.ProductReferenceViewModel.ProductName,
                PriceValue : this.productItem.ProductReferenceViewModel.PriceValue 
            };
        }
        this.trackingService.addToCart(this.productItem);
        return this;
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        this.$frequentPdtDescView.on('click', this.onFrequentPdtDescViewCTAHandler);
        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        this.$frequentPdtDescView.off('click', this.onFrequentPdtDescViewCTAHandler);
        return this;
    }


    /**
     * addToCartClicked
     *
     * @method addToCartClicked
     * @public
     * @chainable
     */
     addToCartClicked() {
        this.$addToCart.on('click', this.oncartClickedHandler);
        return this;
    }

    /**
     * input entered
     *
     * @method inputEntered
     * @public
     * @chainable
     */
    inputEntered() {
        this.$stepperValue.on('keyup', this.onInputEnteredHandler);       
    }
}